// extracted by mini-css-extract-plugin
module.exports = {"body":"_f7bb8e2"};